// c_zeta-suggest.js — ヘッダー検索ドロワーの検索履歴（2-3）。localStorageで最大10件保持し、Enter送信で既存フォームからZETA結果ページへ遷移。入力に応じた関連商品プレビューは負荷対策でPh1では行わず、サジェストAPIによる実装はPh2で対応する。

(function () {
  'use strict';

  const DRAWER_ID = 'search-drawer';
  const HISTORY_KEY = 'c_zeta_search_history';
  const HISTORY_MAX = 10;

  const drawer = document.getElementById(DRAWER_ID);
  if (!drawer) return;

  const input = drawer.querySelector('[name="q"]');
  const form = drawer.querySelector('#predictive-search-form, form.predictive-search__form');
  const historyBox = drawer.querySelector('[data-c_zeta-history]');
  const historyList = drawer.querySelector('[data-c_zeta-history-list]');
  const historyClear = drawer.querySelector('[data-c_zeta-history-clear]');
  if (!input) return;

  // 送信先（ZETA結果ページ）。フォームの action（routes.search_url）を流用
  const searchBase = (form && form.getAttribute('action')) || '/search';

  /**
   * 検索履歴をlocalStorageから読み込む（プライベートブラウジング等で使えない場合は空配列）
   * @returns {string[]} 新しい順のキーワード配列
   */
  const loadHistory = () => {
    try {
      const raw = localStorage.getItem(HISTORY_KEY);
      const list = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(list)) return [];
      return list.filter((kw) => typeof kw === 'string' && kw.trim());
    } catch (e) {
      return [];
    }
  };

  /**
   * キーワードを検索履歴へ保存する（重複は先頭へ移動・最大件数で切り捨て）
   * @param {string} keyword 保存するキーワード
   */
  const saveHistory = (keyword) => {
    const kw = (keyword || '').trim();
    if (!kw) return;
    try {
      const list = loadHistory().filter((item) => item !== kw);
      list.unshift(kw);
      localStorage.setItem(HISTORY_KEY, JSON.stringify(list.slice(0, HISTORY_MAX)));
    } catch (e) {
      // localStorage不可（プライベートブラウジング等）は保存しない仕様
    }
  };

  /**
   * 検索履歴の一覧を描画する（履歴が無い・履歴UIが無い場合は非表示）
   */
  const renderHistory = () => {
    if (!historyBox || !historyList) return;
    const list = loadHistory();
    while (historyList.firstChild) historyList.removeChild(historyList.firstChild);
    if (!list.length) {
      historyBox.hidden = true;
      return;
    }
    const frag = document.createDocumentFragment();
    list.forEach((kw) => {
      const li = document.createElement('li');
      li.className = 'c_zeta-history__item';
      const link = document.createElement('a');
      link.className = 'c_zeta-history__link';
      link.href = searchBase + '?q=' + encodeURIComponent(kw);
      link.textContent = kw;
      link.addEventListener('click', () => saveHistory(kw)); // 再検索で先頭へ
      li.appendChild(link);
      frag.appendChild(li);
    });
    historyList.appendChild(frag);
    historyBox.hidden = false;
  };

  // フォーカス時（＝検索ボタン押下でドロワーが開いた直後）に履歴を表示
  input.addEventListener('focus', () => {
    if (!input.value.trim()) renderHistory();
  });

  // Enter送信（検索実行）でキーワードを履歴へ保存
  if (form) {
    form.addEventListener('submit', () => saveHistory(input.value));
  }

  if (historyClear) {
    historyClear.addEventListener('click', () => {
      try {
        localStorage.removeItem(HISTORY_KEY);
      } catch (e) {
        // localStorage不可の場合は何もしない
      }
      renderHistory();
    });
  }

  // 検索結果ページへ直接遷移した検索（ソート・ページャ等の経由含む）も履歴に反映する
  try {
    const basePath = new URL(searchBase, location.origin).pathname;
    if (location.pathname === basePath) {
      saveHistory(new URLSearchParams(location.search).get('q') || '');
    }
  } catch (e) {
    // URL解釈に失敗した場合は保存しない
  }

  renderHistory();
})();
